import { tc_html } from "./tc";

export function TermsAndConditionsView() {
  return (
    <div className="py-6 px-6">
      <div dangerouslySetInnerHTML={{ __html: tc_html }} />
    </div>
  );
}
